<template>
    <v-dialog v-model="dialogFlow" scrollable max-width="600" persistent>
        <v-card class="mx-auto">
            <v-toolbar color="deep-purple accent-4" dark>
                <v-btn icon @click="closeDialog('CANCEL')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="text-white">WhatsApp Form</v-toolbar-title>
            </v-toolbar>
            <div class="m-4">
                <v-data-table
                    :headers="headers"
                    :items="flowList"
                    :items-per-page="10"
                    class="elevation-1"
                >
                    <template v-slot:item.action="{ item }">
                        <v-btn color="deep-purple accent-4" icon fab dark @click="selectedFlow = item">
                            <v-icon dark>mdi-send</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </div>
            <div v-if="selectedFlow.name" class="m-4">
                <div>
                    <v-text-field
                        v-model="selectedFlow.name"
                        label="Nama"
                        disabled
                    ></v-text-field>
                </div>
                <div>
                    <v-text-field
                        v-model="headerText"
                        label="Header Text"
                    ></v-text-field>
                </div>
                <div>
                    <v-text-field
                        v-model="bodyText"
                        label="Body Text"
                    ></v-text-field>
                </div>
                <div>
                    <v-text-field
                        v-model="footerText"
                        label="Footer Text"
                    ></v-text-field>
                </div>
                <v-row>
                    <v-col cols="4" v-for="(item, index) in selectedFlow.parameters" :key="index">
                        <v-text-field
                            v-model="item.value"
                            :label="item.key"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-btn class="mt-4" @click="sendMessage()" :loading="isLoading" :disabled="isLoading">
                    Kirim
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from "axios";
    import { mapState } from 'vuex'

    export default {
        props: ['dialogFlow', 'selectedSourceChannelId'],

        computed: {
            ...mapState({
                sessionInfo: state => state.session.sessionInfo
            }),
        },

        data: function() {
            return {
                selectedStatus: "ACTIVE",

                headerText: String(),
                bodyText: String(),
                footerText: String(),

                flowList: Array(),

                selectedFlow: Object(),

                headers: [
                    { text: 'ID', value: '_id' },
                    { text: 'Nama', value: 'name' },
                    { text: 'Version', value: 'message_version' },
                    { text: 'Aksi', value: 'action' }
                ],

                isLoading: false,
            }
        },

        methods: {
            getFlow: async function() {
                try {
                    this.isLoading = true

                    const { data } = await axios.get(process.env.VUE_APP_API_URL + '/flow', {
                        params: {
                            page: 1,
                            size: 25,
                            term: String(),
                        }

                    });

                    const result = data.content.map(e => {
                        const keys = Object.keys(e.data)

                        e.parameters = keys.map(el => {
                            return { key: el, value: e.data[el] }
                        })

                        return e
                    })
                    
                    this.flowList = result

                    this.isLoading = false
                } catch (error) {
                    this.isLoading = false
                    console.log("flow", error.message)
                }
            },
            sendMessage: function() {
                this.$emit('sendFlowMessage', this.selectedFlow, {
                    headerText: this.headerText,
                    bodyText: this.bodyText,
                    footerText: this.footerText,
                })

                this.closeDialog()
            },
            closeDialog: function() {
                this.$emit('closeDialog')

                this.headerText = String()
                this.bodyText = String()
                this.footerText = String()
                this.selectedFlow = Object()
            },
        }
    }
</script>